module.exports = __webpack_public_path__ + "img/6aa734d.jpg";